import { render } from "./AccountDetails.vue?vue&type=template&id=12c67225&scoped=true"
import script from "./AccountDetails.vue?vue&type=script&lang=ts"
export * from "./AccountDetails.vue?vue&type=script&lang=ts"

import "./AccountDetails.vue?vue&type=style&index=0&id=12c67225&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-12c67225"

export default script